import CustomTimePicker from './CustomTimePicker';

interface CustomTimeRangeProperties {
  inputLabel?: string;
  inputLabel2?: string;
  value1: string;
  value2: string;
  name1: string;
  name2: string;
  onChangeValue: (name: string, value: string | number) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  error?: boolean;
  // errorMessage?: string;
}

/**
 * Custom time range input fields
 */
function CustomTimeRange({
  inputLabel,
  inputLabel2,
  name1,
  name2,
  value1,
  value2,
  onChangeValue,
  valueRequired,
  readOnly,
  error,
  // errorMessage,
}: CustomTimeRangeProperties) {
  /**
   * handle time select
   */
  const handleValueChange = (name: string, changeValue: string | number) =>
    onChangeValue(name, changeValue);

  return (
    <div className="custom-input-time-wrap">
      <div className="custom-label">
        {inputLabel && (
          <p className={`input-label ${error && 'error'}`}>
            {inputLabel}
            {valueRequired && <span>*</span>}
          </p>
        )}
        {inputLabel2 && (
          <p className="input-label">
            {inputLabel2}
            {valueRequired && <span>*</span>}
          </p>
        )}
      </div>
      <div className="custom-time-range-input">
        <CustomTimePicker
          onChangeValue={handleValueChange}
          name={name1}
          value={value1}
          readOnly={readOnly}
          errorHandle={error}
        />
        <CustomTimePicker
          onChangeValue={handleValueChange}
          name={name2}
          value={value2}
          readOnly={readOnly}
          errorHandle={error}
        />
      </div>
      {/* {error && <p className="custom-input-error-message">{errorMessage}</p>} */}
    </div>
  );
}

CustomTimeRange.defaultProps = {
  inputLabel: '',
  inputLabel2: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  // errorMessage: '',
};

export default CustomTimeRange;
